import { jsxs as z, jsx as g } from "react/jsx-runtime";
import i from "react";
import f, { css as $ } from "styled-components";
import { b as j, e as B } from "../chunks/vendor_rango__tokens.38ee67b0.js";
import { u as ne } from "../chunks/useForwardRef.7bf5d172.js";
const c = {
  Single: "single",
  Range: "range"
};
Object.values(c);
const C = {
  Currency: "Currency",
  Number: "Number",
  Percentage: "Percentage"
};
Object.values(C);
const s = {
  First: "first",
  Second: "second"
}, oe = f.div.withConfig({
  displayName: "RangoSlider",
  componentId: "sc-6zxb6i-0"
})(["& *{margin:0;padding:0;}display:flex;flex-direction:column;height:34px;margin-top:16px;"]), ae = f.div.withConfig({
  displayName: "MultiRange",
  componentId: "sc-6zxb6i-1"
})(["position:relative;"]), E = f.input.withConfig({
  displayName: "Input",
  componentId: "sc-6zxb6i-2"
})(["width:100%;outline:none;appearance:none;-webkit-appearance:none;top:0;left:0;transition-property:background-color,opacity;transition-timing-function:var(--curve-productive-exit);transition-duration:var(--duration-fast-01);&[type='range']{position:absolute;&::before{content:'';position:absolute;top:0;left:0;width:", "%;height:var(--size-half);background-color:", ";border-radius:inherit;cursor:pointer;z-index:", ";}&::-webkit-slider-runnable-track{appearance:none;-webkit-appearance:none;height:var(--size-half);border:transparent;background-color:var(--elements-bg-color-02);cursor:pointer;transition-property:background-color,opacity;transition-timing-function:var(--curve-expressive-entrance);transition-duration:var(--duration-moderate-02);}&::-webkit-slider-thumb{position:relative;-webkit-appearance:none;appearance:none;height:var(--size-2x);width:var(--size-2x);border:transparent;border-radius:var(--border-radius-circular);background-color:var(--elements-bg-color-04);cursor:pointer;margin-top:-6px;z-index:", ";&:active{background-color:var(--active-bg-color);border:var(--default-border-width) solid var(--active-border-color);}}&::-webkit-slider-thumb:active{background-color:var(--active-bg-color);border:var(--default-border-width) solid var(--active-border-color);}", " &::-moz-range-track{appearance:none;-webkit-appearance:none;height:var(--size-half);border:transparent;background-color:var(--elements-bg-color-02);cursor:pointer;transition-property:background-color,opacity;transition-timing-function:var(--curve-expressive-entrance);transition-duration:var(--duration-moderate-02);}&::-moz-range-thumb{position:relative;-webkit-appearance:none;appearance:none;height:var(--size-2x);width:var(--size-2x);border:transparent;border-radius:var(--border-radius-circular);background-color:var(--elements-bg-color-04);cursor:pointer;margin-top:-6px;z-index:", ";&:active{background-color:var(--active-bg-color);border:var(--default-border-width) solid var(--active-border-color);}}&::-moz-range-thumb:hover{background-color:var(--active-bg-color);border:var(--default-border-width) solid var(--active-border-color);}", " &::-ms-fill-lower{background-color:var(--elements-bg-color-04);}&::-moz-range-progress{background-color:var(--elements-bg-color-04);}}"], ({
  width: e
}) => e || "0", ({
  order: e,
  sliderType: F
}) => e === s.First && F === c.Range ? "var(--elements-bg-color-02)" : "var(--elements-bg-color-04)", ({
  order: e
}) => e === s.First ? 1 : 0, ({
  order: e
}) => e === s.First ? 2 : 1, ({
  disableFocus: e
}) => !e && $(["&:focus::-webkit-slider-thumb{", " outline-offset:2px;}"], j), ({
  order: e
}) => e === s.First ? 2 : 1, ({
  disableFocus: e
}) => !e && $(["&:focus::-moz-range-thumb{", " outline-offset:2px;}"], j)), ie = f.div.withConfig({
  displayName: "Track",
  componentId: "sc-6zxb6i-3"
})(["width:100%;margin-bottom:calc((var(--spacing-1_5x) / 2) + var(--spacing-1x));position:relative;"]), W = f.span.withConfig({
  displayName: "Label",
  componentId: "sc-6zxb6i-4"
})(["", " color:var(--text-label-color);margin:0;padding:0;position:absolute;bottom:0;transition-property:all;transition-timing-function:var(--curve-expressive-entrance);transition-duration:var(--duration-moderate-01);width:max-content;left:", "px;"], B, ({
  width: e
}) => e), ce = f.div.withConfig({
  displayName: "Percentages",
  componentId: "sc-6zxb6i-5"
})(["display:flex;justify-content:space-between;margin-top:calc(var(--spacing-2x) + var(--size-half));span{", " color:var(--text-label-color);}"], B), se = i.forwardRef(({
  type: e = c.Single,
  valueType: F = "Percentage",
  initialValue: O = 0,
  finalValue: u = 100,
  step: L = 1,
  onRangeChange: I,
  showValuesRange: K,
  showCurrentValue: D,
  ...T
}, q) => {
  const b = i.useRef(null), A = i.useRef(null), m = i.useRef(null), d = i.useRef(null), N = ne(q), [h, w] = i.useState(null), [x, y] = i.useState(null), [p, G] = i.useState(0), [S, J] = i.useState(0), [U, k] = i.useState(!1);
  i.useEffect(() => {
    w(0), y(100);
  }, []), i.useEffect(() => {
    I && (e === c.Single && I(p), e === c.Range && I({
      lowerValue: p,
      upperValue: S
    }));
  }, [p, S]);
  const Q = (r) => {
    var a;
    const t = parseInt(((a = r.target) == null ? void 0 : a.value) || "0");
    if (w(t), G(+(t * u / 100).toFixed(0)), e !== c.Range)
      return;
    const n = parseInt(m.current.value), o = parseInt(d.current.value);
    n <= d.current.max - 4 && n > o - 4 && (y(n + 4), o == d.current.max && w(parseInt(d.current.max) - 4));
  }, X = (r) => {
    var a;
    if (e !== c.Range)
      return;
    const t = parseInt(((a = r.target) == null ? void 0 : a.value) || "0");
    y(t), J(+(t * u / 100).toFixed(0));
    const n = parseInt(m.current.value), o = parseInt(d.current.value);
    o >= 4 && o < n + 4 && (w(o - 4), n == m.current.min && y(4));
  }, v = (r) => V({
    currencyValue: `R$ ${r}`,
    percentageValue: `${r}%`,
    defaultValue: `${r}`
  }), Y = () => {
    if (e === c.Single)
      return D && `${v(p)}`;
    if (e === c.Range)
      return v(p);
  }, _ = (r, t) => {
    var M, P;
    const o = ((M = N.current) == null ? void 0 : M.offsetWidth) ?? 0, a = ((P = b == null ? void 0 : b.current) == null ? void 0 : P.offsetWidth) ?? 0, l = a / 2, re = r / u, R = +Math.abs(re * (o - 16)).toFixed(2), H = String(r).length;
    function te() {
      return r === u ? R - 16 : R;
    }
    return r ? V({
      currencyValue: Z(H, l, R, r),
      percentageValue: te(),
      defaultValue: ee(H, l, R, r)
    }) : t === s.First ? 0 : V({
      percentageValue: o - a,
      defaultValue: o - 8,
      currencyValue: o - l - 15
    });
  };
  function Z(r, t, n, o) {
    function a() {
      switch (r) {
        case 3:
          return t + 7;
        case 4:
          return t + 11;
        case 5:
          return t + 16;
        case 6:
          return t + 20;
        case 7:
          return t + 25;
        default:
          return t;
      }
    }
    function l() {
      switch (r) {
        case 3:
          return 17;
        case 4:
          return 23;
        case 5:
          return 26;
        case 6:
          return 32;
        default:
          return 0;
      }
    }
    return o === u ? n - a() : r === 1 ? n - 8 : r >= 3 ? n - l() : n - 12;
  }
  function ee(r, t, n, o) {
    function a() {
      switch (r) {
        case 3:
          return t - 4;
        case 4:
          return t;
        case 5:
          return t + 4;
        case 6:
          return t + 9;
        case 7:
          return t + 14;
        default:
          return t;
      }
    }
    function l() {
      switch (r) {
        case 3:
          return 5;
        case 4:
          return 10;
        case 5:
          return 15;
        case 6:
          return 20;
        default:
          return 0;
      }
    }
    return o === u ? n - a() : r === 1 ? n + t : r >= 3 ? n - l() : n;
  }
  const V = ({
    currencyValue: r,
    percentageValue: t,
    defaultValue: n
  }) => {
    switch (F) {
      case C.Currency:
        return r;
      case C.Percentage:
        return t;
      default:
        return n;
    }
  };
  return /* @__PURE__ */ z(oe, { ref: N, "data-test-id": "rango-slider", "data-rango-component": "rango-slider", "data-is-rango": !0, ...T, children: [
    /* @__PURE__ */ z(ie, { children: [
      /* @__PURE__ */ g(W, { width: _(p, s.First), ref: b, children: Y() }),
      e === c.Range && /* @__PURE__ */ g(W, { width: _(S, s.Second), ref: A, children: v(S) })
    ] }),
    /* @__PURE__ */ z(ae, { children: [
      /* @__PURE__ */ g(E, { ...T, ref: m, type: "range", sliderType: e, min: 0, max: 100, step: L, value: h, width: h == null ? void 0 : h.toString(), order: s.First, onChange: Q, onKeyUp: () => k(!1), onMouseDown: () => k(!0), disableFocus: U }),
      e === c.Range && /* @__PURE__ */ g(E, { ...T, ref: d, type: "range", sliderType: e, min: 0, max: 100, step: L, value: x, width: x == null ? void 0 : x.toString(), order: s.Second, onChange: X, onKeyUp: () => k(!1), onMouseDown: () => k(!0), disableFocus: U })
    ] }),
    K && /* @__PURE__ */ z(ce, { children: [
      /* @__PURE__ */ g("span", { children: v(O) }),
      /* @__PURE__ */ g("span", { children: v(u) })
    ] })
  ] });
});
se.displayName = "RangoSlider";
export {
  se as RangoSlider,
  c as SliderType,
  C as SliderValueType
};
